<template>
    <div class="bwi" :variant="variant" :disabled="disabled" @click="click_handler">
        <div class="bwi--text" v-html="text"></div>
        <div class="bwi--icon" v-html="icon"></div>
    </div>    
</template>

<script>
    export default {
        name: 'bwi',
        components: {
        },
        props:
        {
            variant: {
                type: String,
                default: 'primary',
            },
            text: {
                type: String,
                default: 'btn text here',
            },
            icon:
            {
                type: String,
                default: ''
            },
            disabled:
            {
                type: Boolean,
                default: false,
            },
            clicked:
            {
                type: Function,
                default: () => {},
            }
        },
        data() {
            return {
            }
        },
        computed: {
        },
        created()
        {
        },
        mounted() {
        },
        methods:{
            click_handler()
            {
                if(this.disabled) return
                this.clicked()
            }
        },
    }
</script>

<style lang="scss">
    .bwi
    {
        font-weight: 600;
        color:$white;
        padding:$grid-gutter-width/4 $grid-gutter-width;
        border-radius: $border-radius-lg;
        transition:$transition-fade;
        position:relative;
        cursor:pointer;
        &--text
        {
            text-align: center;
        }
        &--icon
        {
            position:absolute;
            top:50%;
            right:$grid-gutter-width/2;
            transform:translateY(-50%);
            width:14px;
            svg
            {
                max-width: 100%;;
                height:auto;
            }
            path
            {
                stroke:$white;
            }
        }
        @each $key,$value in $theme-colors
        {
            &[variant=#{$key}]
            {
                background: $value;
            }
        }

        &[disabled=disabled]
        {
            background: #cccccc !important;
            cursor: default;
        }

        &[variant=light]
        {
            color:$dark-gray;
            svg path
            {
                stroke:$dark-gray;
            }
        }

        &[variant=tertiary]
        {
            background: $tertiary;
            color:$white;
            svg path
            {
                stroke:$white;
            }
        }

        &:hover
        {
            opacity: 0.9;
        }
    }
</style>